module.exports = __webpack_public_path__ + "static/img/2C2P-PCI-PA-DSS.c8b1041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2C2P-PCI-PA-DSS.png
// module id = 1027
// module chunks = 0